var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeethScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7815 1.93292C11.8615 0.929428 10.4933 2.16495 8.99983 2.16495C7.50632 2.16495 6.12628 0.952768 4.25084 1.93292C1.54004 3.34965 1.54004 6.30877 1.54004 7.99182C1.54004 11.4844 4.35811 16.2993 5.85225 16.452C7.3464 16.6045 7.47068 14.4666 8.99983 14.4666C10.529 14.4666 10.6533 16.6045 12.1474 16.452C13.8247 16.2807 16.4596 11.4844 16.4596 7.99182C16.4596 6.30877 16.4596 3.33255 13.7815 1.93292Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20898 5.49023C8.61088 6.02906 9.38932 6.01488 10.7897 5.49023",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeethScan);
export default __webpack_public_path__ + "static/media/teeth_scan.d3838c25b8a82aefb7a4cf9f5f91d9ca.svg";
export { ForwardRef as ReactComponent };